<template>
    <div id="print" class="big_cat_screen" style="background-color: #CA80B1">
        <div class="back_nav" @click="backNav()"><img src="../../assets/back_nav.png"/></div>
        <div class="core_word"><span>核心词汇</span></div>
        <div class="other_word" @click="viewOtherWord"><span>阅读词汇</span></div>

        <audio v-show="false" :src="starAudioUrl" id="star_audio"/>
        <audio v-show="false" :src="greatAudio" id="great_audio"/>

        <div class="star_transition" v-if="showStarTransition && starCount > 0" @click="closeStarTransition">
            <div class="content">
                <div class="content2">
                    <div class="star_show">
                        <div class="icon1"><img id="star_img_1" style="display: none" :src="getStarImg(1)"/></div>
                        <div class="icon2"><img id="star_img_2" style="display: none" :src="getStarImg(2)"/></div>
                        <div class="icon3"><img id="star_img_3" style="display: none" :src="getStarImg(3)"/></div>
                    </div>
                    <div class="star_score">
                        <img class="icon" src="@/assets/star_score_s.png"/><span>{{starCount}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showExitConfirm === 1" class="exit_transition">
            <div class="exit_content">
                <div class="exit_title">还没有完成，确认要放弃吗？</div>
                <div class="game_action">
                    <div class="game_quit" v-on:click.stop="gameQuitClick">
                        <img src="../../Images/game_quit.png"/>
                        <span>Quit</span>
                    </div>
                    <div class="game_continue" v-on:click.stop="gameContinueClick">
                        <img src="../../Images/game_continue.png"/>
                        <span>Continue</span>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isPlayingFail > 0" class="playing_fail" @click="playAudio(isPlayingFail === 1 ? objWordCard.audio : objWordCard.exampleSentenceAudio, isPlayingFail)">
            <img src="@/Images/icon_replay.png" />
        </div>

        <div class="transition" v-if="showTransition">
            <div class="back_nav2" v-on:click.stop="gameQuitClick"><img src="../../assets/back_nav.png"/></div>
            <div class="content">
                <div class="content2">
                    <img class="icon" src="@/Images/jili.png"/>
                    <div id="id_star_count" class="text">
                        <span class="success_tip">祝贺完成!</span>
                    </div>
                    <div class="content3">
                        <div class="transition_comeback" v-on:click.stop="gameQuitClick">
                            <img src="../../Images/transition_comeback.png"/>
                        </div>
                        <div class="transition_next" v-on:click.stop="nextPageClick">
                            <span>思维导图</span>
                            <img src="../../assets/chevron-thin-right.png"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 背景 -->
        <div class="word_back" v-if="!isEmpty(objWordCard)">
            <div class="img_show">
                <div class="re-item">
                    <div class="re-item-front" @click="openClick()">
                        <img class="lazy_img" v-lazy="$qiNiuDomainBase + objWordCard.picture" alt="" />
                    </div>

                    <div class="re-item-back" @click="closeClick()">
                        <pre>{{objWordCard.chineseInterpretation}}</pre>
                    </div>
                    <div class="chinese_intro">中</div>
                </div>
            </div>
            <div class="word_audio">
                <div class="word" @click="playAudioWord(objWordCard.audio)">
                    <div class="audio_playing_white img_play" :style="{display: isPlaying ? '' : 'none'}"></div>
                    <img class="img_play" :style="{display: isPlaying ? 'none' : ''}" src="@/assets/volume_white.png" height="30" width="30"/>
                    <span>{{objWordCard.word}}</span>
                </div>
                <div class="sentence">
                    <div class="sentence_content" v-if="isEmpty(objWordCard.exampleSentenceAudio)">
                        <span>{{objWordCard.exampleSentence}}</span>
                    </div>
                    <div class="sentence_content" v-else @click="playAudio(objWordCard.exampleSentenceAudio, 2)">
                        <div class="audio_playing_white img_play" :style="{display: isSentencePlaying ? '' : 'none'}"></div>
                        <img class="img_play" :style="{display: isSentencePlaying ? 'none' : ''}" src="@/assets/volume_white.png" height="20" width="20"/>
                        <span>{{objWordCard.exampleSentence}}</span>
                    </div>
                </div>
                <div id="record_id" class="record">
                    <div class="recording" :style="{display: isRecording ? 'none' : ''}" @click="evaluatingWithType">
                        <img src="../../assets/icon_not_record_audio.png"/>
                    </div>
                    <div class="audio_record_anim recording" :style="{display: isRecording ? '' : 'none'}"
                         @click="endEvaluating"></div>
                </div>
            </div>
            <div class="page_num">
                <span>{{currentIndex + 1}}</span>/{{wordCards.length}}
            </div>
        </div>

        <div id="previous_page" :style="{marginLeft: getStateWidth() + 'px'}" class="previous_page" @click="previousClick" v-show="false"><img src="@/assets/question_left.png" /></div>
        <div id="next_page" class="next_page" @click="nextClick" v-show="false"><img src="@/assets/question_right.png" /></div>

        <audio v-show="false" :src="audioUrl" id="musicMp3" @ended="playEnded" />
    </div>
</template>

<script>

    import $ from "jquery";
    import {Indicator} from "mint-ui";
    import Utils from '@/pages/Program/util2.js';

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top', (height-width)/2 );
            vPrint.css('left', 0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
        }
    }

    export default {
        data() {
            return {
                courseId: 0,
                lessonId: 0,
                currentIndex: 0,
                objWordCard: {},
                wordCards: [],
                isRecording: false,
                audioUrl: "",
                isPlaying: false,
                isSentencePlaying:false,
                showExitConfirm: 0,
                showTransition: false,
                starAudioUrl: null,
                starCount: 0,
                showStarTransition: false,
                greatAudio:"https://img.xiaohuasheng.cn/great.mp3",
                wordChanging: false,
                isPlayingFail: 0,
                otherWordTitle: "",
                pingceTimeOut:null
            }
        },
        methods: {
            backNav:function(){
                this.showExitConfirm = 1;
            },
            gameQuitClick() {
                setTimeout(() => {
                    this.cancelEvaluating();
                }, 100);

                this.showExitConfirm = 0;
                this.$router.go(-1);
            },
            getStateWidth: function () {
                return this.getCount(this.$store.state.statusheight) > 22 ? 10 : 0;
            },
            gameContinueClick() {
                this.showExitConfirm = 0;
            },
            nextPageClick: function () {
                setTimeout(() => {
                    this.cancelEvaluating();
                }, 100);

                this.$router.replace({
                    name: 'MPractice', query: {lessonId: this.lessonId, modeType:0}
                });
            },
            viewOtherWord: function () {
                this.$router.push({
                    name: 'MLessonWord', query: {lessonId: this.lessonId}
                });
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            showStatus:function (status) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:showStatusView:" + status;
                }

                if (vPlatform === 4) {
                    window.note.showStatusView(status);
                }
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            playAudioWord(audio) {
                this.playAudio(audio, 1);
            },
            playAudio(audio, type) {
                let that = this;
                let musicMp3 = document.getElementById('musicMp3');

                if (that.isPlaying || that.isSentencePlaying) {
                    that.playEnded();
                }

                that.audioUrl = that.$qiNiuDomainBase + audio;
                musicMp3.src = that.audioUrl;
                that.isPlayingFail = 0;

                setTimeout(() => {
                    if (type === 1) {
                        that.isPlaying = true;
                    } else {
                        that.isSentencePlaying = true;
                    }

                    let playPromise = musicMp3.play();

                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                        }).catch((e) => {
                            that.isPlayingFail = type;

                            if (type === 1) {
                                that.isPlaying = false;
                            } else {
                                that.isSentencePlaying = false;
                            }

                            let vError = JSON.stringify(e);
                            window.console.log("播放失败:" + vError);
                        });
                    } else {
                        that.isPlayingFail = type;

                        if (type === 1) {
                            that.isPlaying = false;
                        } else {
                            that.isSentencePlaying = false;
                        }

                        window.console.log("播放失败");
                    }
                }, 200);
            },
            playEnded() {
                let that = this;
                var musicMp3 = document.getElementById('musicMp3');
                musicMp3.pause();

                if (that.isPlaying) {
                    this.isPlaying = false;
                }

                if (that.isSentencePlaying) {
                    this.isSentencePlaying = false;
                }
            },
            evaluatingWithType() {
                let that = this;
                let vPlatform = that.judgePlatform();
                let wordCard = that.wordCards[that.currentIndex];
                that.isRecording = true;
                that.showPreviousNext();
                that.playEnded();

                if (vPlatform === 3) {
                    // 3-app平台IOS平台
                    // document.location = "readingclubapp:evaluatingWithType:2:" + wordCard.word;
                    if (that.pingceTimeOut != null) {
                        clearTimeout(that.pingceTimeOut);
                        that.pingceTimeOut = null;
                    }

                    that.pingceTimeOut = setTimeout(function () {
                        that.evaluatingResultForTimeout(1, 1);
                    }, 5000);
                } else if (vPlatform === 4) {
                    // 4-app平台android平台
                    window.note.evaluatingWithType(2, wordCard.word);
                }
            },
            endEvaluating() {
                let that = this;
                that.isRecording = false;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    // 3-app平台IOS平台
                    // document.location = "readingclubapp:endEvaluating";
                    if (that.pingceTimeOut != null) {
                        clearTimeout(that.pingceTimeOut);
                        that.pingceTimeOut = null;
                    }

                    that.pingceTimeOut = setTimeout(function () {
                        that.evaluatingResultForTimeout(1, 1);
                    }, 800);
                } else if (vPlatform === 4) {
                    // 4-app平台android平台
                    window.note.endEvaluating();
                }
            },
            evaluatingResult(result) {
                let that = this;
                that.evaluatingResultForTimeout(result, 0);
            },
            evaluatingResultForTimeout(result, isTimeout) {
                // 返回测评结果处理
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3 && isTimeout !== 1) {
                    // 3-app平台IOS平台
                    return;
                }

                let vScore = parseFloat(result);
                that.starCount = that.getProgramStarCount(vScore);
                that.showStarTransition = true;
                that.isRecording = false;

                setTimeout(() => {
                    that.starAudioUrl = that.getProgramAudioUrl(that.starCount);

                    setTimeout(() => {
                        const starAudio = document.getElementById('star_audio');
                        starAudio.play();
                    }, 200);

                    for (let i = 1; i <= 3; i++) {
                        $("#star_img_" + i).show(200 + i*100, function(){
                            // if (i === 3) {
                            //     setTimeout(() => {
                            //         that.showStarTransition = false;
                            //     }, 800);
                            // }
                        });
                    }

                    // 跳下一题
                    setTimeout(() => {
                        that.closeStarTransition();
                        that.nextClick();
                    }, 1500);
                }, 200);
            },
            cancelEvaluating() {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    // 3-app平台IOS平台
                    // document.location = "readingclubapp:cancelEvaluating";
                    if (that.pingceTimeOut != null) {
                        clearTimeout(that.pingceTimeOut);
                        that.pingceTimeOut = null;
                    }
                } else if (vPlatform === 4) {
                    // 4-app平台android平台
                    window.note.cancelEvaluating();
                }
            },
            evaluatingError: function (errorCode) {
                // let that = this;
                window.console.log("错误码：" + errorCode);

                // if (errorCode === 10118) {
                //     // 重新开始录入
                //     that.closeStarTransition();
                //     that.evaluatingCount += 1;
                //
                //     that.starAudio = that.getProgramAudioUrl(0);
                //     setTimeout(() => {
                //         const starAudio = document.getElementById('star_audio');
                //         starAudio.play();
                //     }, 200);
                //
                //
                // } else {
                //     Toast("错误码：" + errorCode);
                // }
            },
            sentenceStartRecordAnimation() {
                this.isRecording = true;
            },
            sentenceEndRecordAnimation() {
                this.isRecording = false;
            },
            sentenceCloseIndicator() {
                Indicator.close();
            },
            closeStarTransition() {
                this.showStarTransition = false;
            },
            getStarImg(count) {
                let that = this;
                return count <= that.starCount ? require('@/assets/star_score_s.png') : require('@/assets/star_score_n.png');
            },
            previousClick() {
                let that = this;

                if (that.wordChanging) {
                    return;
                }

                that.wordChanging = true;
                that.closeClick();
                $("#previous_page").hide();

                if (that.currentIndex > 0) {
                    setTimeout(function () {
                        that.currentIndex -= 1;
                        that.objWordCard = that.wordCards[that.currentIndex];
                        let wordAudio = that.objWordCard.audio;
                        that.wordChanging = false;
                        that.showPreviousNext();

                        setTimeout(function () {
                            if (!that.isEmpty(wordAudio)) {
                                that.playAudioWord(wordAudio);
                            }
                        }, 200);
                    }, 300);
                }
            },
            openClick() {
                $(".re-item-front").addClass("open");
                $(".re-item-back").addClass("open");
                $(".chinese_intro").hide(500);
            },
            closeClick() {
                $(".re-item-front").removeClass("open");
                $(".re-item-back").removeClass("open");
                $(".chinese_intro").show(1000);
            },
            nextClick: function() {
                let that = this;

                if (that.wordChanging) {
                    return;
                }

                that.wordChanging = true;
                that.closeClick();
                $("#next_page").hide();
                let delayTime = 300;

                if (that.currentIndex < that.wordCards.length - 1) {
                    setTimeout(function () {
                        that.currentIndex += 1;
                        that.objWordCard = that.wordCards[that.currentIndex];
                        let wordAudio = that.objWordCard.audio;
                        that.wordChanging = false;
                        that.showPreviousNext();

                        setTimeout(function () {
                            if (!that.isEmpty(wordAudio)) {
                                that.playAudioWord(wordAudio);
                            }
                        }, 200);
                    }, delayTime);
                } else {
                    //  最后一题
                    setTimeout(function () {
                        that.showTransition = true;
                        Utils.$emit('setFinishPart', that.lessonId, 1);
                        window.console.log(that.lessonId);

                        const greatAudio = document.getElementById('great_audio');
                        greatAudio.play();
                        $("#success_icon").show(800, function(){});
                    }, 1500);
                }
            },
            showPreviousNext() {
                let that = this;
                let previousPage = $("#previous_page");
                let nextPage = $("#next_page");

                if (that.isRecording || that.wordChanging) {
                    previousPage.hide();
                    nextPage.hide();
                    return;
                }

                if (that.currentIndex <= 0) {
                    previousPage.hide();
                } else {
                    previousPage.show();
                }

                if (that.currentIndex < that.wordCards.length) {
                    nextPage.show();
                } else {
                    nextPage.hide();
                }
            },
        },
        created() {
            let that = this;
            // 客户端调用方法组
            window.sentenceStartRecordAnimation = that.sentenceStartRecordAnimation;
            window.sentenceEndRecordAnimation = that.sentenceEndRecordAnimation;
            window.sentenceCloseIndicator = that.sentenceCloseIndicator;
            window.evaluatingResult = that.evaluatingResult;
            window.evaluatingError = that.evaluatingError;
        },
        beforeCreate() {
            let that = this;
            let vLessonId = that.getCount(this.$route.query.lessonId);
            let vCourseId = that.getCount(this.$route.query.courseId);
            let url = "mathStart/getFollowReadWord/" + vLessonId + "/1";

            this.$axios.get(url).then((response) => {
                that.wordCards = response.data;
                that.courseId = vCourseId;
                that.lessonId = vLessonId;
                that.cardIndex = 0;

                that.hideStatusAndStopAudio();

                let wordAudio = "";
                if (!that.isEmpty(that.wordCards)) {
                    that.objWordCard = that.wordCards[0];
                    that.otherWordTitle = "阅读词汇(" + that.objWordCard.newWordCount + ")";
                    wordAudio = that.objWordCard.audio;
                    that.showPreviousNext();
                }

                setTimeout(() => {
                    transformView();

                    setTimeout(function () {
                        if (!that.isEmpty(wordAudio)) {
                            that.playAudioWord(wordAudio);
                        }
                    }, 200);
                }, 100);
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    img { pointer-events: none; }

    .big_cat_screen {
        -webkit-user-select:none;
        -khtml-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
    }
    .back_nav {
        position: absolute;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav img {
        width: 30px;
        height: 30px;
    }

    .core_word {
        position: absolute;
        left: calc(50% - 110px);
        top: 18px;
        width: 90px;
        height: 32px;
        background-color: #ffffff;
        border-radius: 16px;
        -webkit-border-radius: 16px;
        -moz-border-radius: 16px;
        color: #CA80B1;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 15px;
        font-weight: bold;
    }

    .core_word span {

    }

    .other_word {
        position: absolute;
        right: calc(50% - 110px);
        top: 18px;
        width: 90px;
        height: 32px;
        background-color: #0000006a;
        border-radius: 16px;
        -webkit-border-radius: 16px;
        -moz-border-radius: 16px;
        color: #ffffffba;
        font-size: 15px;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .word_back {
        position: absolute;
        width: calc(190vmin - 104*1.9px);
        height: calc(100vmin - 104px);
        top: 74px;
        bottom: 30px;
        background-color: #0000006a;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        display: flex;
    }
    .word_back .img_show {
        margin: 30px;
    }
    .word_back .img_show img {
        width: calc(100vmin - 164px);
        height: calc(100vmin - 164px);
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }

    .word_back .word_audio {
        width: calc(90vmin - 123.6px);
        height: calc(100vmin - 104px);
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        align-content: center;
    }
    .word_back .word {
        width: calc(90vmin - 123.6px);
        display: flex;
        justify-content: center;
    }
    .word_back .word .img_play {
        width: 30px;
        height: 30px;
        margin-right: 5px;
    }
    .word_back .word span {
        color: white;
        font-size: 22px;
        font-weight: bold;
    }
    .word_back .sentence {
        width: calc(90vmin - 123.6px);
        display: flex;
        justify-content: center;
        text-align: center;
    }
    .word_back .sentence .sentence_content .img_play {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 2px;
        vertical-align: middle;
    }
    .word_back .sentence .sentence_content span {
        color: white;
        font-size: 13px;
        vertical-align: middle;
    }
    .word_back .record {
        width: calc(90vmin - 123.6px);
        display: flex;
        justify-content: center;
        margin-top: 50px;
        font-size: 0;
    }
    .word_back .page_num {
        position: absolute;
        bottom: 30px;
        right: 30px;
        color: white;
        text-align: center;
        font-size: 15px;
    }
    .word_back .page_num span {
        font-size: 18px;
        font-weight: bold;
    }
    .word_back .record .recording img {
        width: 70px;
        height: 70px;
    }
    .audio_record_anim {
        width: 70px; /*宽高尺寸任意增减*/
        height: 70px;
        background: url(../../assets/record_audio_anim.png) no-repeat;
        background-size: 1000% 100%;
        -webkit-animation: line-slow 0.8s steps(9) infinite;
        animation: line-slow 0.8s steps(9) infinite;
    }
    @keyframes line-slow {
        0% {
            background-position: 0% 0%;
        }
        100% {
            background-position: 100% 0%;
        }
    }
    @-webkit-keyframes line-slow {
        0% {
            background-position: 0% 0%;
        }
        100% {
            background-position: 100% 0%;
        }
    }

    /*确认按钮样式*/
    .big_cat_screen .exit_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.9);
        z-index: 1003;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .big_cat_screen .exit_content {
        position:relative;
    }
    .big_cat_screen .exit_content .exit_title {
        color: white;
        font-size: 18px;
        text-align: center;
        margin-bottom: 50px;
    }
    .big_cat_screen .exit_content .game_action .game_quit {
        display: inline-block;
        margin-right: 100px;
    }
    .big_cat_screen .exit_content .game_action .game_continue {
        display: inline-block;
    }
    .big_cat_screen .exit_content .game_action .game_quit img, .big_cat_screen .exit_content .game_action .game_continue img {
        display: block;
        width: 70px;
        margin-bottom: 10px;
    }
    .big_cat_screen .exit_content .game_action .game_quit span, .big_cat_screen .exit_content .game_action .game_continue span {
        display: block;
        text-align: center;
        font-size: 20px;
        color: white;
    }

    .big_cat_screen .transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .big_cat_screen .transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmin;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .big_cat_screen .transition .content2 {
        text-align: center;
    }

    .big_cat_screen .transition .content3 {
        text-align: center;
    }
    .big_cat_screen .transition .content .icon {
        margin-bottom: 10px;
        width: 35%;
    }
    .big_cat_screen .transition .content .text {
        width: 100%;
        margin-top: 5px;
        color: white;
    }
    .big_cat_screen .transition .content .text span {
        display: block;
        text-align: center;
    }
    .big_cat_screen .transition .content .text .success_tip {
        font-size: 24px;
    }
    .transition_next {
        margin-top: 30px;
        display: inline-block;
        background-color: #07A745;
        width: 150px;
        height: 40px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        vertical-align: middle;
        animation: zoom 1s infinite;
        text-align: center;
    }
    .transition_next span {
        display: inline-block;
        font-size: 16px;
        color: white;
        line-height: 39px;
        vertical-align: middle;
    }
    .transition_next img {
        display: inline-block;
        width: 15px;
        vertical-align: middle;
    }
    .transition_comeback {
        margin-top: 30px;
        margin-right: 25px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        font-size: 0;
    }
    .transition_comeback img {
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .back_nav2 {
        position: absolute;
        z-index: 1003;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav2 img {
        width: 30px;
        height: 30px;
    }

    .previous_page {
        position: absolute;
        z-index: 1000;
        top: calc(50vmin - 30px);
        left: 0;
    }
    .next_page {
        position: absolute;
        z-index: 1000;
        top: calc(50vmin - 30px);
        right: 0;
    }
    .previous_page img, .next_page img {
        width: 60px;
        height: 60px;
    }

    .re-item {
        width: calc(100vmin - 164px);
        height: calc(100vmin - 164px);
        position: relative;
    }

    .re-item .chinese_intro {
        position: absolute;
        bottom: 10px;
        right: 10px;
        background-color: rgba(0, 0, 0, 0.60);
        border-radius: 3px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        padding-left: 5px;
        padding-right: 5px;
        font-size: 12px;
        color: white;
        z-index: 201;
    }

    .re-item-front,
    .re-item-back {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: transparent;
        backface-visibility: hidden;
        -webkit-transition: all 1.5s;
        -moz-transition: all 1.5s;
        -ms-transition: all 1.5s;
        -o-transition: all 1.5s;
        overflow: hidden;
    }

    .re-item-back {
        position: relative;
        transform: rotateY(-180deg);
        -webkit-transform: rotateY(-180deg);
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        text-align: center;
    }
    .re-item-back pre {
        padding-left: 10px;
        padding-right: 10px;
        font-weight: bold;
        white-space: pre-wrap; /* css-3 */
        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
    }

    .re-item-front.open {
        transform: rotateY(180deg);
        cursor: default;
        transition: transform 1s;
    }
    .re-item-back.open {
        transform: rotateY(0deg);
        cursor: default;
        transition: transform 1s;
    }

</style>
